export default {
  NAV: 'nav',
  HELP: 'help',
  NONE: null,
};
